import { render } from "./RepeatedCalls.vue?vue&type=template&id=25144014&scoped=true"
import script from "./RepeatedCalls.vue?vue&type=script&lang=js"
export * from "./RepeatedCalls.vue?vue&type=script&lang=js"

import "./RepeatedCalls.vue?vue&type=style&index=0&id=25144014&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25144014"]])

export default __exports__